import { useContext, useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { Row, Spinner } from 'reactstrap'
import { AuthenticationContext } from './Auth/authentication.context'
import { useBranding } from './contexts/BrandingContext'
import server from './server'

import { router } from './Routes'
import FaviconUpdater from './components/FaviconUpdater'

import './App.css'
import './scss/theme.scss'

function App() {
  const { isGroupMode, primaryColor, secondaryColor } = useBranding()
  const {
    isLoading,
    setUser,
    setIsAdmin,
    setStatus,
    setBannerMsg,
    setError,
    setIsLoading,
  } = useContext(AuthenticationContext)

  const token = localStorage.getItem('accessToken')

  // Safely parse the user data, handling both encrypted and JSON formats
  let sessionUser = null
  try {
    const userString = localStorage.getItem('user')
    if (userString) {
      sessionUser = JSON.parse(userString)
    }
  } catch (error) {
    console.error('Error parsing user from localStorage:', error)
    // If parsing fails, the data might be encrypted or invalid
    // We'll set sessionUser to null and let the app fetch fresh user data
  }

  const sessionIsAdmin = localStorage.getItem('isAdmin')
  const sessionUserStatus = localStorage.getItem('status')
  const sessionBannerMsg = localStorage.getItem('bannerMsg')

  useEffect(() => {
    const root = document.documentElement
    const body = document.body
    if (isGroupMode) {
      if (primaryColor) root.style.setProperty('--brand-sidebar-color', primaryColor)
      // The buttons color is the group's accent everywhere (buttons, tables,
      // highlights). Without one, fall back to the sidebar color so the portal
      // never shows the stock indigo next to the group's own color.
      const accentColor = secondaryColor || primaryColor
      if (accentColor) root.style.setProperty('--brand-buttons-color', accentColor)
      else root.style.removeProperty('--brand-buttons-color')
      root.style.setProperty('--brand-sidebar-width', '280px')
      body.setAttribute('data-sidebar', 'colored')
      body.classList.add('branding-group-mode')
      // Load group portal font (DM Sans) for distinct typography
      const id = 'group-portal-font'
      if (!document.getElementById(id)) {
        const link = document.createElement('link')
        link.id = id
        link.rel = 'stylesheet'
        link.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&display=swap'
        document.head.appendChild(link)
      }
    } else {
      root.style.removeProperty('--brand-sidebar-color')
      root.style.removeProperty('--brand-buttons-color')
      root.style.removeProperty('--brand-sidebar-width')
      body.setAttribute('data-sidebar', 'dark')
      body.classList.remove('branding-group-mode')
      const fontLink = document.getElementById('group-portal-font')
      if (fontLink) fontLink.remove()
    }
  }, [isGroupMode, primaryColor, secondaryColor])

  useEffect(() => {
    setIsLoading(false)
    if (token) {
      if (sessionUser) {
        setUser(sessionUser)
        // setIsAdmin(sessionIsAdmin ? sessionIsAdmin : false);
        setStatus(sessionUserStatus ? sessionUserStatus : 0)
        setBannerMsg(sessionBannerMsg)
      } else {
        setIsLoading(true)
        getUser()
      }
    }
  }, [])

  const getUser = () => {
    server
      .get('/users', { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => {
        setIsAdmin(response.data.user.role === 'admin' ? true : false)
        setUser(response.data.user)
        setError(null)
        setIsLoading(false)
      })
      .catch((e) => {
        // setUser(null)
        // if (e.response.status === 401) {
        //   setUser(null)

        // }
        setIsLoading(false)
      })
  }

  return (
    <>
      <FaviconUpdater />
      {isLoading ? (
        <Row
          className='justify-content-center align-items-center'
          style={{ height: '100vh' }}
        >
          <Spinner color='primary' />
        </Row>
      ) : (
        <RouterProvider className='App' router={router} />
      )}
    </>
  )
}

export default App
